import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldArray, useFormikContext } from "formik";
import React from "react";
import { Button } from "react-bootstrap";
import { invPaymentInit } from "utils/HelperInvoicePayment";
import InvoicePaymentList from "./InvoicePaymentList";
import { NumericFormat } from "react-number-format";
import useInvoicePaymentSummary from "hooks/invoice/useInvoicePaymentSummary";
import moment from "moment";
import { useInvoiceInitContext } from "contexts/invoicePage/InvoiceInitContext";
export default function InvoicePayment() {
    var _useInvoicePaymentSummary = useInvoicePaymentSummary(), sumPayment = _useInvoicePaymentSummary.sumPayment, totalToBePaid = _useInvoicePaymentSummary.totalToBePaid, countPayment = _useInvoicePaymentSummary.countPayment, sumPriceIncDiscount = _useInvoicePaymentSummary.sumPriceIncDiscount;
    var modalInvoiceModalState = useInvoiceInitContext().modalInvoiceModalState;
    var _useFormikContext = useFormikContext(), values = _useFormikContext.values, setFieldValue = _useFormikContext.setFieldValue;
    var setModalInvPayment = modalInvoiceModalState.setModalInvPayment;
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-[1017px] pagezoom",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "card card-st-3 pt-[15px] px-[39px] pb-[73px]",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "fs-24",
                                children: [
                                    "ข้อมูลการรับชำระใบแจ้งหนี้เลขที่ ",
                                    values.doc_number
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-16 tc-10",
                                        children: "อ้างอิงระบบ"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "fs-16",
                                        children: [
                                            " ",
                                            values.do_doc_number_ref || "-"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-16 tc-10",
                                        children: "อ้างอิง"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "fs-16",
                                        children: [
                                            " ",
                                            values.refer || "-"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("hr", {
                        className: "my-4",
                        style: {
                            opacity: 0.1
                        }
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center fs-16 gap-[65px] w-full h-[147px]",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex flex-col justify-between w-full h-full",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex justify-between",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                children: "มูลค่าเต็มใบแจ้งหนี้ :"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx(NumericFormat, {
                                                        displayType: "text",
                                                        thousandSeparator: ",",
                                                        decimalScale: 2,
                                                        fixedDecimalScale: true,
                                                        value: sumPriceIncDiscount
                                                    }),
                                                    " ",
                                                    "บาท"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex justify-between",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                children: "มูลค่าสุทธิที่ต้องชำระทั้งสิ้น :"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "tc-4",
                                                children: [
                                                    /*#__PURE__*/ _jsx(NumericFormat, {
                                                        displayType: "text",
                                                        thousandSeparator: ",",
                                                        decimalScale: 2,
                                                        fixedDecimalScale: true,
                                                        value: totalToBePaid
                                                    }),
                                                    " ",
                                                    "บาท"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex justify-between",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    "มูลค่าที่ชำระแล้ว ",
                                                    countPayment,
                                                    " รายการ :"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx(NumericFormat, {
                                                        displayType: "text",
                                                        thousandSeparator: ",",
                                                        decimalScale: 2,
                                                        fixedDecimalScale: true,
                                                        value: sumPayment
                                                    }),
                                                    " ",
                                                    "บาท"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex flex-col justify-between w-full h-full",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex justify-between items-end fs-20",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                children: "มูลค่าที่รอชำระ"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex justify-center items-center aspect-[228/74] p-[14px] min-w-[228px] bg-[#FFEDE0] rounded-[8px]",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "fs-28 font-semibold tc-5",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(NumericFormat, {
                                                            displayType: "text",
                                                            thousandSeparator: ",",
                                                            decimalScale: 2,
                                                            fixedDecimalScale: true,
                                                            value: totalToBePaid
                                                        }),
                                                        " ",
                                                        "บาท"
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex justify-between items-end",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "tc-16 fs-16",
                                                children: [
                                                    "วันที่ครบกำหนด :",
                                                    " ",
                                                    moment(values.doc_due_date, "YYYY-MM-DD").format("DD/MM/YYYY")
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(Button, {
                                                type: "button",
                                                onClick: function() {
                                                    var lastIndex = values.factNewInvPayment.length;
                                                    setModalInvPayment(function(prev) {
                                                        return _object_spread_props(_object_spread({}, prev), {
                                                            open: true,
                                                            paymentIndex: lastIndex,
                                                            shouldInitForm: true,
                                                            modeInv: "create"
                                                        });
                                                    });
                                                },
                                                className: "btn-st-3",
                                                children: "ชำระเงิน"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("hr", {
                        className: "my-4",
                        style: {
                            opacity: 0.1
                        }
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card card-st-3 pt-[15px] pb-[32px] px-[39px] mt-[19px]",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "font-bold fs-18",
                        children: "การรับชำระเงิน"
                    }),
                    /*#__PURE__*/ _jsx(FieldArray, {
                        name: "factNewInvPayment",
                        render: function(arrayHelpers) {
                            return /*#__PURE__*/ _jsx(InvoicePaymentList, {
                                arrayHelpers: arrayHelpers
                            });
                        }
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "flex gap-[24px] items-end",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    children: "มูลค่าที่รับชำระ"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex justify-end items-center aspect-[228/74] p-[14px] w-[228px] bg-[#FF731D] rounded-[8px]",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "fs-28 text-[white]",
                                        children: [
                                            /*#__PURE__*/ _jsx(NumericFormat, {
                                                displayType: "text",
                                                thousandSeparator: ",",
                                                decimalScale: 2,
                                                fixedDecimalScale: true,
                                                value: totalToBePaid
                                            }),
                                            " ",
                                            "บาท"
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
